<template>
  <v-layout>
    <v-navigation-drawer
      v-model="drawer"
      :permanent="$vuetify.display.mdAndUp"
      :rail="$vuetify.display.md"
      :expand-on-hover="$vuetify.display.md"
      data-cy="main-drawer"
    >
      <v-list nav>
        <company-switch />
        <v-list-item
          v-for="item in items"
          :key="item.text"
          :prepend-icon="item.icon"
          :title="item.text"
          :active="$route.path === item.href || $route.path.startsWith(item.href + '/')"
          color="primary"
          @click="goTo(item.href)"
        />

        <v-divider />

        <v-list-subheader v-if="!$vuetify.display.md">
          {{ currentUser.email }}
        </v-list-subheader>

        <v-list-item
          prepend-icon="person"
          title="Moj profil"
          :active="$route.path === '/me'"
          color="primary"
          data-cy="me"
          @click="goTo('/me')"
        />

        <v-list-item
          prepend-icon="logout"
          title="Odjavi se"
          data-cy="logout"
          @click="logout"
        />
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      data-cy="main-app-bar"
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.display.smAndDown"
        aria-label="Odpri navigacijski meni"
        data-cy="main-menu-button"
        @click.stop="drawer = !drawer"
      />
      <v-app-bar-title>SiteLOG</v-app-bar-title>
    </v-app-bar>
    <v-main>
      <v-container max-width="1440">
        <router-view />
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
  import router from '../router';
  import CompanySwitch from './components/CompanySwitch';

  export default {
    components: {CompanySwitch},
    data: () => ({
      drawer: null,
      loginDialog : false,
      loginEmail   : null,
      loginPassword: null,
    }),
    computed: {
      currentCompany() {
        return this.$store.getters.currentCompany;
      },
      currentUser() {
        return this.$store.getters.currentUser;
      },
      items() {
        if ('admin' === this.currentUser.role) {
          return [
            { icon: 'assignment', text: 'Projekti', href: '/projects' },
            { icon: 'people', text: 'Uporabniki', href: '/users'}
          ];
        } else {
          return [
            { icon: 'assignment', text: 'Projekti', href: '/projects' },
          ];
        }
      }
    },
    methods: {
      goTo(href) {
        if (this.$route.path !== href) {
          router.push(href);
        }
      },
      logout() {
        window.localStorage.clear();
        router.push('/login');
      }
    }
  }
</script>
